<template>
    <ModalComponent
        name="crear-sesion"
        :title="'Crear nueva sesión para el evento: ' + evento.nombre_completo"
        v-on:close="() => close(false)"
    >
        <template v-if="!loading">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
                <FormSesion :sesion="sesion" :evento="evento"/>

                <div class="row">
                    <div class="col-12">
                        <Button type="submit" data-cy="crear-sesion" name="button">Crear</Button>
                    </div>
                </div>
            </ValidationObserver>
        </template>
        <template v-else>
            <div class="row">
                <div class="col-12" style="height: 200px">
                    <LoaderComponent/>
                </div>
                <div class="col-12 text-center">
                    <h3 v-if="evento && evento.cerrar_butacas_abonados == 1">
                        Cerrando butacas de los abonados...
                    </h3>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import FormSesion from '@/components/backend/eventos/sesiones/FormSesion';

    export default {
        props: {
            name: String,
            title: String,
            evento: Object
        },
        data() {
            return {
                sesion: {},
                loading: false
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'crear-sesion', creado);
            },
            crearSesion() {
                this.loading = true;
                this.sesion.filters = {};
                this.sesion.evento_id = this.evento.id;
                this.sesion.fecha = moment(this.sesion.fecha_zulu).format('YYYY-MM-DD HH:mm:ss');
                this.sesion.end_session_date = moment(this.sesion.end_session_date).format('YYYY-MM-DD HH:mm:ss');
                this.sesion.fecha_zulu = moment(this.sesion.fecha_zulu).add(2, 'hours').toISOString();

                if (this.sesion.fecha_cierre_venta) {
                    this.sesion.fecha_cierre_venta = moment(this.sesion.fecha_cierre_venta).format('YYYY-MM-DD HH:mm:ss');
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.crear'), this.sesion).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearSesion();
                }
            },
        },
        components: {
            ModalComponent, LoaderComponent, FormSesion
        },
    }
</script>
